module.exports = __webpack_public_path__ + "static/NewJune-bold-5cee8a8d3c4a36b01a35e061dff39530.woff2";